<template>
    <div style="height: inherit;">
      <div v-if="loading" style="height: inherit;">
        <loading-page ref="loadingPage"></loading-page>
      </div>
      <div v-else style="height: inherit;">
        <div>
          <Header :image="image"></Header>
        </div>

        <div class="content__positioning distancing">
          <!-- <h1 class="headlin-text">Privacy Policy</h1> -->
          <div class="adivi-text text" v-html='text'></div>
          <div class="go-back-btn">
            <button class="btn-back" @click="$router.go(-1)">
              <span class="btn__text__normal">Back</span>
            </button>
          </div>
        </div>

        <footer-view></footer-view>
      </div>
    </div>
</template>

<script>
import HTTPRequest from '../../plugins/utils/HttpRequest.js'
import Config from '../../plugins/utils/Config.js'
import Header from './../../components/design/HeaderDesign.vue'
import LoadingPage from './../../components/loading/LoadingScreen.vue'
import FooterView from './../../components/footer/FooterView.vue'
import toast from '@utils/toast'
export default {
  name: 'PrivacyAndPolicy',
  data: function () {
    return {
      text: '',
      config: Config,
      json_response: '',
      loading: true,
      image: 'pp'
    }
  },
  components: {
    Header,
    FooterView,
    LoadingPage
  },
  methods: {
    makeApiCall () {
      var request = new HTTPRequest()
      var url = '/get/privacy'
      var body = {
        API_KEY: '',
        data: {
          format: 'html'
        }
      }
      request.makeRequest('POST', url, body).then((response) => {
        this.json_response = JSON.parse(response)
        if (this.json_response.code === 0) {
          this.text = this.json_response.data[0].body
          setTimeout(() => {
            this.$refs.loadingPage.end()
            this.loading = false
            toast.successMessage('Text receive')
          }, 600)
        } else {
          toast.errorMessage(this.json_response.message)
        }
      }).catch((error) => {
        toast.errorMessage(error)
      })
    }
  },
  created: function () {
    this.makeApiCall()
  }
}
</script>
